module.exports = {
  mmzs: '注：由于追溯系统手持PAD密码不支持全部特殊字符，在重置追溯系统账号密码时，特殊字符仅能使用#或@',
  mqzwdbcl: '目前暂无待办需要处理哦！',
  cxyzzjjkfz: '程序猿正在紧急开发中，请稍安勿躁！',
  yhtymh: '颐海统一门户',
  thtymhqxqbxt: '颐海统一门户旗下所有系统',
  ghbj: '更换背景',
  hymr: '还原默认',
  ckgd: '查看更多',
  qd: '确定',
  qr: '确认',
  qx: '取消',
  tc: '退出',
  czcg: '操作成功',
  wxts: '温馨提示',
  cw: '错误',
  jg: '警告',
  // 登录页
  loginPage: {
    qhqyzm: '请获取验证码',
    tysfglpt: '统一门户系统',
    zhdl: '账号登录',
    yhmygbh: '用户名/员工编号',
    sjhm: '手机号码',
    xgmm: '修改密码',
    mm: '密码',
    qxgcsmm: '请修改初始密码',
    mmydqqxgmm: '密码已到期，请修改密码',
    xmmbnyjmmxt: '新密码不能与旧密码相同',
    xmm: '新密码',
    ymm: '原密码',
    qrxmm: '确认新密码',
    wjmm: '忘记密码',
    xyhddl: '向右滑动登录',
    yzcg: '验证成功',
    smdl: '扫码登录',
    qywxsm: '企业微信扫码',
    ddsm: '钉钉扫码',
    fssm: '飞书扫码',
    ewmysx: '二维码已失效',
    sxewm: '刷新二维码',
    dxyzm: '短信验证码',
    hqyzm: '获取验证码',
    xyb: '下一步',
    dlsjyz: '登录手机验证',
    wbll: '外部链接',
    bq: '版权',
    mmbyz: '密码不一致',
    hcxhq: '后重新获取',
    qxsrzqdsjhm: '请先输入正确的手机号码',
    qsrdxyzm: '请输入短信验证码',
    qsryhm: '请输入用户名',
    qxzsjhm: '请选择手机号码',
    fscg: '发送成功',
    yhmbnwk: '用户名不能为空',
    yhmwgzf: '用户名为3-12个字符',
    yhmbnczkg: '用户名/员工编号不能存在空格',
    mmbnwk: '密码不能为空',
    ymmbnwk: '原密码不能为空',
    mmwsfzhlw: '密码为身份证后6位',
    mmzswzmsztszf: '密码至少为8位字母、数字、特殊字符组合',
    mmzswzmsztszfnew: '密码至少为8位字母、数字、特殊字符组合，特殊字符仅能使用#或者@'
  },
  // 首页
  homePage: {
    ty: '泰语',
    hy: '韩语',
    gh: '工号',
    zh: '账号',
    gw: '岗位',
    sj: '手机',
    yx: '邮箱',
    yy: '语言',
    pf: '皮肤',
    bj: '背景',
    yh: '代理',
    xtyyxz: '系统语言选择',
    zwjt: '中文简体',
    zwft: '中文繁体',
    yw: '英文',
    qb: '全部',
    wdyy: '我的应用',
    dlbjxgqh: '登录背景效果切换',
    zjbj: '中间背景',
    ybbj: '右边背景',
    qhdlr: '切换代理人',
    xtpfqh: '系统皮肤切换'
  },
  // 后台返回信息
  interface: {
    dlsx: '登录失效',
    dlsxqcxdl: '登录失效，请重新登录',
    fail: 'code返回fail',
    404: '网络异常',
    '0000': '默认错误',
    1000: '参数错误',
    2000: '同步HR组织或部门失败',
    3000: '系统角色名称已存在',
    3001: '存在已设置员工，不能删除',
    3002: '短信平台异常',
    8001: '微信用户获取失败',
    9997: '登录失效',
    9998: '非法请求',
    9999: '系统错误',
    10001: '名称已存在',
    // 10021: '唯一标识已存在',
    10002: '操作失败',
    10003: '员工编号已存在',
    10004: '员工编号：纯数字',
    10005: '手机号：非正常手机号',
    10006: '密码：8-16位字符',
    10007: '身份证件号：输入不正确',
    10008: '护照证件号：输入不正确',
    10009: '邮箱：格式不正确',
    10010: '原密码不正确',
    10011: '账户名或密码错误，登录失败',
    10012: '账户名不存在',
    10013: '用户登录已过期',
    10014: '因连续登录失败超十次，账号已锁定',
    10015: '验证码不正确',
    10016: '手机号码无效',
    10017: '验证码已超时',
    10018: '二维码失效，请刷新重试',
    10019: '每日同一手机号验证码只允许发送三次',
    10020: '验证码发送失败',
    10021: '自动登录失败',
    10022: '登录失败五次以上，请输入验证码',
    10023: '上传图片服务器失败',
    10024: '当前部门存在人员，无法删除！',
    10025: '当前组织存在部门，无法删除！',
    10026: '当前组织存在子公司，无法删除！',
    10027: '当前部门存在子部门，无法删除！',
    10028: '手机号已存在',
    10029: '证件号已存在',
    10030: '邮箱已存在',
    10031: '所选岗位存在下级岗位，无法删除！',
    10032: '登录密码已过期，请在“企业微信”或点击“忘记密码”重新设置密码',
    10033: '登录密码还有%s天过期，请及时修改密码',
    10034: '首次登录，请先修改密码',
    10035: '所选应用已被引用，无法删除！',
    10036: '所选角色已被引用，无法删除！',
    10037: '当前组织存在人员，无法删除！',
    10038: '链接地址已存在',
    10039: '再输入错误%s次账户将锁定！',
    10040: '密码至少为8位字母、数字、特殊字符组合，特殊字符仅能使用#或者@'
  }
}
